
export default {
  categoryList : {
    overflowX: 'hidden',
    overflowY: 'scroll',
    height: 'calc(100vh - 160px)'
  },

  categoryEntry: {
    background: '#fff',
    cursor: 'pointer'
  },

  categoryEntrySelected: {
    background: '#e6f7ff',
    cursor: 'pointer',
    fontWeight: 'bold'
  },
  pager:{
    position: 'absolute',
    width: 800,
    top: 50,
    zIndex: 100
  },
  icon: {
    marginTop: 4,
    marginLeft: -5,
    paddingRight: 10
  }
}


// WEBPACK FOOTER //
// ./src/lawreport/lawReport.css.js